import { render, staticRenderFns } from "./gift.vue?vue&type=template&id=258def2f&"
import script from "./gift.vue?vue&type=script&lang=js&"
export * from "./gift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports